import { TYPE_PROMOTION } from 'BannerPromotions/enums';

type OrderShowModalReturn = {
  id: number;
  modal: string;
};

export const orderShowModalBill: OrderShowModalReturn[] = [
  {
    id: 1,
    modal: TYPE_PROMOTION.AVISO_PIX,
  },
];
